import _ from 'lodash';

import { PREF_CHANGED_EVENT } from './constants';

export const readNotificationPref = storageKey => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }

  try {
    return window.localStorage.getItem(storageKey) === 'true';
  } catch {
    return false;
  }
};

export const writeNotificationPref = (storageKey, enabled) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, String(enabled));
  } catch {
    // ignore storage errors
  }
};

export const broadcastChange = (storageKey, enabled) => {
  if (typeof window === 'undefined' || !_.isFunction(window.CustomEvent)) {
    return;
  }

  window.dispatchEvent(
    new window.CustomEvent(PREF_CHANGED_EVENT, {
      detail: { key: storageKey, value: enabled },
    }),
  );
};
